import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    marginBottom: pxToRem(16),
    selectors: {
      '& .ms-MessageBar-icon': {
        paddingTop: pxToRem(2),
      },
    },
  },
  actionRequiredTitle: {
    color: theme.palette.neutralDark,
    fontWeight: 600,
    marginTop: pxToRem(12),
  },
  actionRequiredBody: {
    display: 'block',
    color: theme.palette.neutralDark,
    fontWeight: 400,
  },
  details: {
    margin: 0,
    padding: 0,
    selectors: {
      li: {
        color: theme.palette.neutralDark,
        display: 'list-item',
        fontSize: pxToRem(14),
        listStyle: 'inside',
        position: 'relative',
      },
    },
    marginTop: pxToRem(8),
  },
  showLinkButton: {
    selectors: {
      '&:hover': {
        color: theme.palette.themePrimary,
        textDecoration: 'none',
      },
    },
    marginTop: pxToRem(14),
  },
  showLinkText: {
    selectors: {
      '&.ms-Link, &.ms-Link:hover': {
        color: theme.palette.themePrimary,
        fontSize: pxToRem(14),
      },
    },
  },
});
